import React, { createContext, useEffect, useState } from "react";
import useSWR from "swr";
import { LoadingC } from "../components";
import useLocalization from "../hooks/useLocalization";

interface domainInterface {
  domainType?: string;
  googleAnalytics?: string;
  scripts?: string;
  googleTagManager?: string;
  favIconPath?: string;
  id?: number;
  instagramId?: string;
  landing?: string;
  logoPath?: string;
  name?: string;
  nameEn?: string;
  originalPicturePath?: string;
  primaryColor?: string;
  rules?: null;
  slogan?: string;
  supportPhone?: string[];
  description?: string;
  whatsapp?: string;
  telegramAccount?: string;
  telegramChannel?: string;
  aparat?: string;
  youtube?: string;
  headerPublic?: string;
  symbol_native?: string;
  currencyId?: number;
  purchaseCurrencyPrice?: number;
  purchaseCurrencySlug?: number;
}
export const DomainContext = createContext<{
  data: domainInterface;
}>({
  data: {},
});

const DomainProvider = ({ children, generals }: any) => {
  const {
    setLanguage,
    getLanguage,
    getCurrency,
    setCurrency,
    sendLocalizationCallback,
    localization,
  } = useLocalization();
  const { data, isValidating } = useSWR(`/domain/config`, {
    onSuccess: (data) => {
      const {
        primaryColor,
        language,
        languageKey,
        isRtl,
        currencyId,
        symbol_native,
      } = data;

      primaryColor &&
        window?.less?.modifyVars({ "@primary-color": primaryColor });
      const lang = getLanguage()?.language;
      const currency = getCurrency()?.currencyId;
      console.log("sjjjjjj", data);

      // @ts-ignore
      const lang01 = JSON.parse(localStorage.getItem("localization"))?.language;
      const currency01 = JSON.parse(
        // @ts-ignore
        localStorage.getItem("localization")
      )?.currencyId;

      // console.log("getLanguage()?.language",getLanguage()?.language, getLanguage())

      if (!lang || !lang01) {
        setLanguage(language, languageKey, isRtl);
      }
      if (!currency || !currency01) {
        setCurrency(currencyId, symbol_native);
      }
    },
  });

  useEffect(() => {
    if (data) {
      const {
        primaryColor,
        language,
        languageKey,
        isRtl,
        currencyId,
        symbol_native,
      } = data;

      primaryColor &&
        window?.less?.modifyVars({ "@primary-color": primaryColor });
      const lang = getLanguage()?.language;
      const currency = getCurrency()?.currencyId;

      // @ts-ignore
      const lang01 = JSON.parse(localStorage.getItem("localization"))?.language;
      const currency01 = JSON.parse(
        // @ts-ignore
        localStorage.getItem("localization")
      )?.currencyId;

      // console.log("getLanguage()?.language",getLanguage()?.language, getLanguage())

      if (!lang || !lang01) {
        setLanguage(language, languageKey, isRtl);
      }
      if (!currency || !currency01) {
        setCurrency(currencyId, symbol_native);
      }
    }
  }, [isValidating]);

  if (!data) return <LoadingC />;
  // && process.env.NODE_ENV !== "development"
  return (
    <DomainContext.Provider value={{ data }}>{children}</DomainContext.Provider>
  );
};

export default DomainProvider;
